import { gql } from '@apollo/client';
export { GetFullSettings, ListCreditsSettings, ListUserCredits } from './settings';

export const getProfile = gql`
  query Profile {
    me {
      _id
      email
      fullName
      permissions
    }
  }
`;
